export default __webpack_public_path__ + "static/media/fb.85f24732.svg";